module.exports = __webpack_public_path__ + "images/a067dbdeffc6d121cb6dd0ff386f77c1.jpg";